interface NumberFormatOptions extends Intl.NumberFormatOptions {
  fallback?: string;
}

const number = (value: number, { fallback = '-', maximumFractionDigits = 2, ...options }: NumberFormatOptions = {}) => {
  if (Number.isNaN(value) || !Number.isFinite(value)) {
    return fallback;
  }
  return new Intl.NumberFormat('ko-KR', { ...options, maximumFractionDigits }).format(value);
};

interface BusinessNumberFormatOptions {
  mask?: string;
}

const businessNumber = (value: string, { mask }: BusinessNumberFormatOptions = {}) => {
  return value.replace(/^(\d{3})(\d{2})(\d{5})$/, mask ? '$1-**-*****' : '$1-$2-$3');
};

export const formatter = {
  number,
  businessNumber,
};
